export default __webpack_public_path__ + "static/media/artboard.84e1c067.svg";